import axios from './_axios_config';
import { request, buildQuery } from './_process_request';

export const ct_transactions = {
    // params.type é obrigatório: 'purchase' | 'sale'
    async getTransactions(params) {
        return request(axios.get(`/transactions${buildQuery(params)}`));
    },

    async getTransaction(id) {
        return request(axios.get(`/transactions/${id}`));
    },

    async createTransaction(data) {
        return request(axios.post('/transactions', data));
    },

    async disableTransaction(id) {
        return request(axios.patch(`/transactions/${id}/disable`));
    },

    async enableTransaction(id) {
        return request(axios.patch(`/transactions/${id}/enable`));
    },

    async getReceipt(id) {
        return request(axios.get(`/transactions/${id}/receipt`));
    },
};
